/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { AccessKeysContext } from "../context/AccessKeysContext"
import { REQUIRED_MESSAGE } from "./defaultMessages"
import React, { Component } from "react"
import { Col, Form, FormGroup } from "react-bootstrap"
import { Field as FinalFormField } from "react-final-form"

export default class RadiosField extends Component {
  validate = (value, accessKeys) => {
    const { name } = this.props
    const ak = accessKeys[name] || {}
    const { required, requiredMessage = REQUIRED_MESSAGE } = {
      ...this.props,
      ...ak
    }
    if (required && value === undefined) {
      return requiredMessage
    }
  }

  state = {
    pickedOption: this.props.initialCustomValue
  }

  render() {
    return (
      <AccessKeysContext.Consumer>
        {(accessKeys = {}) => {
          const { name } = this.props
          const ak = accessKeys[name] || {}
          const {
            items,
            hidden,
            placeholder,
            label,
            className,
            xs,
            lg,
            xl,
            md,
            sm,
            xsHidden,
            smHidden,
            mdHidden,
            lgHidden,
            xlHidden,
            disabled,
            hasServerErrors,
            noFormGroup,
            children
          } = { ...this.props, ...ak }

          if (hidden) {
            return false
          }

          return (
            <FinalFormField
              name={name}
              component="input"
              type="text"
              placeholder={placeholder}
              className="form-control"
              validate={(value) => {
                return this.validate(value, accessKeys)
              }}
            >
              {({ input, meta }) => {
                const metaError = meta.error && (meta.touched || hasServerErrors)
                const hasError = metaError || meta.submitError
                const cl = {
                  "d-none": xsHidden || smHidden || mdHidden || lgHidden || xlHidden,
                  "d-sm-block": !smHidden,
                  "d-sm-none": smHidden,
                  "d-md-block": !mdHidden,
                  "d-md-none": mdHidden,
                  "d-lg-block": !lgHidden,
                  "d-lg-none": lgHidden,
                  "d-xl-block": !xlHidden,
                  "d-xl-none": xlHidden,
                  "col-no-padding": true
                }
                if (className) {
                  cl[className] = true
                }
                const hasColParam =
                  xs || lg || xl || md || sm || xsHidden || smHidden || mdHidden || lgHidden || xlHidden
                const colParams = { className: cl, xs, lg, xl, md, sm }
                let body = [
                  <div className="d-flex" key={label}>
                    {label && <Form.Label>{label}</Form.Label>}
                    {children}
                  </div>,
                  <div key="radio" className="radiofields d-flex">
                    {items.map((item) => (
                      <Col key={item.name}>
                        <Form.Label className={hasError && "radiosfield-error "}>
                          <FinalFormField
                            disabled={disabled}
                            id={name}
                            name={name}
                            component="input"
                            type="radio"
                            value={item.name}
                            checked={this.state.pickedOption === item.name || this.props.checked === item.name}
                            onChange={input.onChange}
                          />
                          {item.label}{" "}
                        </Form.Label>
                      </Col>
                    ))}
                  </div>,
                  <React.Fragment key="error">
                    {hasError && <p className="required-message">{meta.error || meta.submitError}</p>}
                  </React.Fragment>
                ]

                if (!noFormGroup) {
                  body = <FormGroup>{body}</FormGroup>
                }

                if (hasColParam) {
                  body = <Col {...colParams}>{body}</Col>
                }
                return body
              }}
            </FinalFormField>
          )
        }}
      </AccessKeysContext.Consumer>
    )
  }
}
